import React from 'react'
import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'
import {useGetGenericHtmlPage} from '../../custom-api/hooks/use-get-generic-html-page'
import {Helmet} from 'react-helmet'
import loadable from '@loadable/component'
import {Box, useMultiStyleConfig} from '@chakra-ui/react'
import SanitizedHtml from '../../components/html-sanitizer'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useLocation} from 'react-router'

const PageNotFound = loadable(() => import('./../page-not-found'))

const GenericHtmlPage = () => {
    const {res} = useServerContext()
    const {data, error, isLoading} = useGetGenericHtmlPage()
    const entries = {...data}
    const stylesPolicies = useMultiStyleConfig('Policies')
    const location = useLocation()
    const {customParams} = getConfig()

    if (error || (data === null && !isLoading)) {
        if (res) res.status(404)
        return <PageNotFound />
    }

    const seo = entries?.seo_standard || {}
    const metaTitle = seo?.meta_title
    const metaDescription = seo?.meta_description
    const currentPath = 'https://' + customParams.currentHost + location.pathname

    const webPageSchemaMarkup = {
        '@context': 'https://schema.org/',
        '@type': 'WebPage',
        name: metaTitle,
        description: metaDescription,
        url: currentPath,
    }

    return (
        <>
            <Helmet>
                {metaTitle && <title>{metaTitle}</title>}
                {metaDescription && <meta name="description" content={metaDescription} />}
                <script type="application/ld+json">
                    {JSON.stringify(webPageSchemaMarkup, null, 2)}
                </script>
            </Helmet>
            <Box {...stylesPolicies.container} __css={{...stylesPolicies}}>
                <SanitizedHtml as="div" html={data?.html} />
            </Box>
        </>
    )
}

export default GenericHtmlPage
